module.exports = __webpack_public_path__ + "img/KKS_Pricelist.8d522142.png";